import { openScheduledJobForEditing } from "../../designer-view-actions";
import { getSdInstance } from "../helpers";
import type { ToolHandlerGroup } from "../types";

export const scheduledJobTools: ToolHandlerGroup = {
  sync: {
    ui_project_list_scheduled_jobs: () => {
      const sd = getSdInstance();

      const scheduledJobs: any[] = sd.scheduledJobsProvider?.state?.scheduledJobs || sd.state?.scheduledJobs || [];

      if (scheduledJobs.length === 0) {
        return { jobs: [], message: "No scheduled jobs found in this project." };
      }

      const jobs = scheduledJobs.map((job: any) => ({
        id: job.id,
        name: job.name || job.jobName
      }));

      return { jobs, count: jobs.length };
    }
  },

  async: {
    ui_project_navigate_to_scheduled_job: async (input) => {
      const { jobId } = input;
      if (!jobId) return { error: "jobId is required" };

      const sd = getSdInstance();
      const scheduledJobs: any[] = sd.scheduledJobsProvider?.state?.scheduledJobs || sd.state?.scheduledJobs || [];
      const job = scheduledJobs.find((item: any) => String(item.id) === String(jobId));

      if (!job) {
        const available = scheduledJobs.map((item: any) => `${item.id} (${item.name || item.jobName})`);
        return {
          error: `Scheduled job "${jobId}" not found.`,
          availableJobs: available
        };
      }

      await openScheduledJobForEditing(sd, jobId, {
        ensureView: true
      });

      return {
        success: true,
        message: `Opened scheduled job "${job.name || job.jobName}" for editing.`,
        jobId: String(job.id),
        jobName: job.name || job.jobName
      };
    }
  }
};
